import { useState } from 'react';
import { sendEvent, useEventNotification } from '../../features/visual-analytics/hooks/events';
import { ModalPortal } from '../modal-portal/ModalPortal';

import styles from './MessageBoxes.module.scss';

const MSGShowErrorMessage = 'ShowErrorMessage';

export function showErrorMessage(message: string | React.ReactNode) {
  sendEvent(MSGShowErrorMessage, message);
}

export function ErrorMessage() {
  const [activeMessage, setActiveMessage] = useState<string | React.ReactNode | null>(null);

  useEventNotification(
    MSGShowErrorMessage,
    (tpe: string, contentInput: any) => {
      setActiveMessage(contentInput);
    },
    [],
  );

  if (!activeMessage) return null;

  return (
    <ModalPortal
      // blurTarget={document.getElementById('dashboardClientArea')}
      close={() => {}}
    >
      <div className={styles.errorMessageBox}>
        <div className={styles.title}>Error</div>
        {activeMessage}
        <div className={styles.buttonSection}>
          <button
            onClick={() => {
              setActiveMessage(null);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </ModalPortal>
  );
}

export function nonImplemented() {
  showErrorMessage('This feature is not yet implemented');
}
